const IconSearch = () => {
  return (
    <path
      d="M11.5 5C14.8137 5 17.5 7.68629 17.5 11C17.5 12.3865 17.028 13.6617 16.2383 14.6777L19.0957 17.5352L18.0352 18.5967L15.1777 15.7383C14.1617 16.528 12.8865 17 11.5 17C8.18629 17 5.5 14.3137 5.5 11C5.5 7.68629 8.18629 5 11.5 5ZM11.5 6.5C9.01472 6.5 7 8.51472 7 11C7 13.4853 9.01472 15.5 11.5 15.5C13.9853 15.5 16 13.4853 16 11C16 8.51472 13.9853 6.5 11.5 6.5Z"
      fill="currentColor"
    />
  );
};

export default IconSearch;
